import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { InitParams, SOURCE_WEB, SOURCE_WEB_OPTIONS } from './calendar.const';
import { ModalMobileInfoComponent } from '@web-frontend/shared/components/modal-mobile-info';
import { MatDialog } from '@angular/material/dialog';
import { RmFilter } from '@web-frontend/shared/components/globals/rm-filter';
import { Subject, Subscription } from 'rxjs';
import {
  AuthService,
  AssetSearchService,
  AssetService,
  CalendarApi,
  CalendarService,
  ClockAbsenceService,
  DealService,
  DynamicPropertyService,
  FinalService,
  ProjectService,
  SandboxService,
  StatusService,
  StorageService,
} from '@web-frontend/shared/services';
import {
  BudgetsSetting,
  ClockAbsence,
  Company,
  Deal,
  DynamicPropertyRef,
  Feature,
  FeatureUser,
  FIRST_DAY_CALENDAR,
  IBudgetsSetting,
  Lang,
  TypeRol,
} from '@tacliatech/types';
import { CompanyModuleService } from '@web-frontend/shared/services/company';
import { TranslateService } from '@ngx-translate/core';
import { RmCalendar } from './calendar.types';
import {
  CalendarEvent,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { MatMenuTrigger } from '@angular/material/menu';
import { BudgetService } from '@web-frontend/shared/services/budgets';
import { AmplitudeService } from '@web-frontend/shared/amplitude.service';
import { getDateStrResum, RemoveEmpty } from '@web-frontend/shared/utils';
import { addDays, format, isSameDay, subDays, eachDay } from 'date-fns';

import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import * as moment from 'moment-timezone';
import { finalize, map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { CreateDealService } from '@web-frontend/shared/components/create-deal';
import { ScrollService } from '@web-frontend/shared/services/scroll';
import { TutorialService } from '@web-frontend/shared/services/tutorial';
import { VideoService } from '@web-frontend/shared/components/modal-video/video.service';
import { PermissionService } from '@web-frontend/shared/services/permissions';
import { ToastService } from '@web-frontend/shared/services/toast/toast.service';
import AmplitudeEvents from 'src/types/amplitude.enum';
import { timestampToHour } from '@web-frontend/shared/utils/dateAndTime';
import { ModalEnableModuleComponent } from './modal-enable-module/modal-enable-module.component';
import {
  AddClockAbsenceService,
  ShowDetailClockAbsenceService,
} from '../../../shared/components/clock-absences';
import { AnalyticsService } from '@web-frontend/shared/services/analytics/analytics.service';
import { PlatformService } from '../../../shared/components/platform-disable-content/platform.service';
import { ModulesService } from '@web-frontend/shared/services/modules/modules.service';
import { FeatureTypes } from '@web-frontend/shared/enums/module';
type CalendarEventWithAbsence = CalendarEvent & {
  isAbsence?: boolean;
};

@Component({
  selector: 'roma-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarComponent implements OnInit, OnDestroy, AfterViewInit {
  sourceSearch = SOURCE_WEB;
  sourceOptions!: RmFilter.Filter;
  iconDialog: [boolean, string] = [
    false,
    'assets/icons/gl_title-information-outline.svg',
  ];
  resize$ = this.sandBoxService.screenBusChannel$;

  private sub$ = new Subscription();

  private flightRequest = new Subscription();

  @ViewChildren('menuMoreDealsLimitTrigger')
  menuMoreDealsLimit: QueryList<MatMenuTrigger>;

  @ViewChild('weekly', { read: ElementRef })
  weeklyCalendar: ElementRef;

  @ViewChild('daily', { read: ElementRef })
  dailyCalendar: ElementRef;

  @Input()
  showHeader = true;

  @Input()
  set searchParameters(params) {
    this.searchParams = {
      ...params,
      from: this.searchParams.from,
      to: this.searchParams.to,
    };
    this.requestElements();
  }

  isAdmin$ = this.authService.isAdmin$;
  events: CalendarEventWithAbsence[] = [];
  view: CalendarView = CalendarView.Month;
  viewDate: Date = new Date();
  todayDate: Date = new Date();
  loading = false;
  locale!: Lang;
  calendar: RmCalendar.StorageControls = {
    type: {
      deal: true,
      activity: false,
      absence: false,
    },
    showEndOfWeek: true,
    view: 'MONTH',
  };
  excludeDays: number[] = [];

  refresh: Subject<void> = new Subject();
  defaultSettings = new BudgetsSetting();
  eventLimit = 4;
  cellActive!: { day: number; date: Date; events: CalendarEventWithAbsence[] };
  searchParams = InitParams;
  openMobileViewType = false;
  iconClockXMark = 'assets/icons/clock-xmark.svg';

  private loadingClickGhostEvent!: CalendarEventWithAbsence;
  isLoading = false;

  featureRefUser = FeatureUser;

  scrollDown$ = this.scrollService.scrollDown$;

  academyLink = '';
  showVideoTutorialButton = false;

  idActiveModules$ = this.companyModuleService.idActiveModules$;

  resCalendar: {
    recurrences: CalendarApi.GhostDeal[];
    deals: CalendarApi.ApiDeal[];
    activities: unknown[];
    absences?: ClockAbsence.Output[];
  } = { recurrences: [], deals: [], activities: [], absences: [] };

  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private assetService: AssetService,
    private assetSearchService: AssetSearchService,
    private finalService: FinalService,
    private dynamicPropertyService: DynamicPropertyService,
    private companyModuleService: CompanyModuleService,
    private projectService: ProjectService,
    private statusService: StatusService,
    private i18n: TranslateService,
    private sandBoxService: SandboxService,
    private budgetService: BudgetService,
    private calendarSearchService: CalendarService,
    private amplitudeService: AmplitudeService,
    private dealService: DealService,
    private domSanitzer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private createDealService: CreateDealService,
    private scrollService: ScrollService,
    public tutorialService: TutorialService,
    private video: VideoService,
    private permissionService: PermissionService,
    private toastService: ToastService,
    private readonly clockAbsenceService: ClockAbsenceService,
    private readonly showDetailClockAbsenceService: ShowDetailClockAbsenceService,
    private readonly addClockAbsenceService: AddClockAbsenceService,
    private analyticsService: AnalyticsService,
    private platformService: PlatformService,
    private readonly modulesService: ModulesService
  ) {
    this.matIconRegistry.addSvgIcon(
      'burger_icon',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/icons/table-horizontal.svg'
      )
    );
  }

  ngAfterViewInit(): void {
    this.resolveCalendarScrollPosition();
  }

  ngOnInit(): void {
    this.getCompanySettings();
    this.requestDynamicProperties();
    this.resolveCalendarElementStorage({ option: 'READ' });
    this.resolveLanguage();
    this.watchTranslation();
    this.watchRefreshList();
    this.generateDate();
    this.requestElements();

    this.sub$.add(
      this.tutorialService
        .get('calendar')
        .pipe(
          finalize(() => {
            this.draw();
          })
        )
        .subscribe((res) => {
          this.academyLink = res?.academy;
          this.showVideoTutorialButton = Boolean(res?.source);
        })
    );

    this.sub$.add(
      this.resize$.subscribe(() => {
        this.requestElements();
      })
    );
  }

  checkPermission(
    feature: Feature.Purchasable | FeatureUser.Purchasable
  ): boolean {
    return this.permissionService.allowedFeature(feature);
  }

  ngOnDestroy(): void {
    this.sub$.unsubscribe();
  }

  resolveCalendarScrollPosition(): void {
    if (this.weeklyCalendar) {
      this.weeklyCalendar.nativeElement.scrollTop += 648;
    }
    if (this.dailyCalendar) {
      this.dailyCalendar.nativeElement.scrollTop += 648;
    }
  }

  validateAbsence() {
    this.validateActiveModules('CLOCK_HOURS').then((isActive) => {
      if (!isActive) {
        this.showActiveModal();
        return;
      }

      this.changeCalendarElement('ABSENCE');
    });
  }

  showActiveModal() {
    const dialogRef = this.dialog.open(ModalEnableModuleComponent, {});

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'activated') {
        this.isLoading = true;
        this.refreshComponent();
        this.updateModuleState();
        this.analyticsService.trackEvent({
          sources: ['amplitude'],
          eventName: AmplitudeEvents.calendar_absence_activate,
        });
      } else {
        return;
      }
    });
  }

  async updateModuleState(): Promise<void> {
    await this.companyModuleService
      .activateCompanyFeature(FeatureTypes.CLOCK_HOURS)
      .toPromise();
    await this.companyModuleService
      .activateCompanyFeature(FeatureTypes.ABSENCES)
      .toPromise();
    this.changeCalendarElement('ABSENCE');
    await this.modulesService.init().toPromise();
    this.refreshComponent();
  }
  changeCalendarElement(type: 'DEAL' | 'ACTIVITY' | 'ABSENCE'): void {
    const typeKeyMap: { [key: string]: string } = {
      DEAL: 'deal',
      ACTIVITY: 'activity',
      ABSENCE: 'absence',
    };

    const key = typeKeyMap[type];
    if (!key) {
      throw new Error(`Unknown type: ${type}`);
    }

    const activeTypes = Object.values(this.calendar.type).filter(
      (value) => value
    ).length;

    if (activeTypes === 1 && this.calendar.type[key]) {
      console.warn('At least one type must remain active.');
      return;
    }

    this.calendar.type[key] = !this.calendar.type[key];

    this.analyticsService.trackEvent({
      sources: ['amplitude'],
      eventName: this.calendar.type.absence
        ? AmplitudeEvents.calendar_absence_enable
        : AmplitudeEvents.calendar_absence_disable,
    });

    this.resolveCalendarElementStorage({ option: 'SAVE' });
    this.requestElements();
    this.draw();
  }

  changeCalendarView(view: RmCalendar.View): void {
    this.calendar.view = view;
    this.resolveCalendarElementStorage({ option: 'SAVE' });
    this.viewDateChange();
    this.resolveCalendarScrollPosition();
    this.draw();
  }

  toggleShowEndOfWeek(evt: MatSlideToggleChange): void {
    this.calendar.showEndOfWeek = evt.checked;
    this.resolveShowEndOfWeek();
    this.resolveCalendarElementStorage({ option: 'SAVE' });
    this.draw();
  }

  openMenuMoreDealsLimitEvt(evt: {
    day: number;
    date: Date;
    events: CalendarEventWithAbsence[];
  }): void {
    this.cellActive = evt;
    this.draw();
  }

  closeMenuMoreDealsLimitEvt(): void {
    this.cellActive = null;
    this.draw();
  }

  closeMatMenuMoreDeals(): void {
    for (const el of this.menuMoreDealsLimit) {
      el.closeMenu();
    }
  }

  isActiveCell(date: Date): boolean {
    return date && this.cellActive
      ? isSameDay(date, this.cellActive.date)
      : false;
  }

  goToHiring(date) {
    if (!this.checkPermission(FeatureUser.Deal.create)) {
      this.toastService.show({
        text: this.i18n.instant('permissions.errors.permissionStr'),
        type: 'error',
        msDuration: 5000,
      });
      return;
    }
    localStorage.setItem('newDealDate', date);
    localStorage.setItem('newDealDateCalendar', this.view);
    this.createDealService
      .open()
      .pipe(
        map((res) => {
          if (res) {
            this.requestElements();
          }
        })
      )
      .subscribe();
  }

  eventDropped({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    if (event.start.getTime() === newStart.getTime()) return;
    event.start = newStart;

    this.dateDragEnter({
      dropData: {
        event: {
          id: event.id,
          end: newEnd || newStart,
          start: event.start,
          title: event.title,
        },
        date: event.start,
      },
    });
  }

  transformDate = (from: Date, to: Date): string => {
    const origin = from;
    const originData = getDateStrResum(origin);
    const destinationData = getDateStrResum(to);

    const transformInitWeek =
      destinationData.formattedDate +
      `T${originData.hour}:${originData.minute}`;

    return transformInitWeek;
  };

  dateDragEnter(drag: {
    dropData: { event: CalendarEventWithAbsence; date: Date };
  }): void {
    const { start, end, id, meta } = drag.dropData.event;
    this.amplitudeService.sendEvent({
      event: AmplitudeEvents.deal_calendar_move,
    });
    this.loading = true;
    this.draw();

    const newDay = getDateStrResum(drag.dropData.date);
    const newEndDate = end;

    newEndDate.setFullYear(
      Number(newDay.year),
      Number(newDay.month) - 1,
      Number(newDay.day)
    );

    const endResume = getDateStrResum(newEndDate);
    const initDate = this.transformDate(start, newEndDate);

    if (!meta?.isGhostDeal) {
      this.updateEvent({
        id: String(id),
        start: initDate,
        end: endResume.formattedFullMinutesT,
      });
      this.dealService
        .updateOne(String(id), {
          dates: {
            initTimestamp: new Date(start).getTime(),
            endTimestamp: new Date(end).getTime(),
          },
        })
        .pipe(
          finalize(() => {
            this.loading = false;
            this.draw();
            this.viewDate = drag.dropData.date;
          })
        )
        .subscribe();
    }
  }

  updateEvent(values: { id: string; start: string; end: string }): void {
    const { id } = values;
    const events = [...this.events];
    const index = events.findIndex((e) => e.id === id);
    if (index === -1) return;

    Object.assign(events[index].meta, {
      dates: {
        initTimestamp: new Date(values.start).getTime(),
        endTimestamp: new Date(values.end).getTime(),
      },
    });
    events[index] = this.attachToLocalEvents(events[index].meta);
    this.events = [...events];
    this.draw();
  }

  viewDateChange(): void {
    this.generateDate();
    this.requestElements();
  }

  async handleClickEvent(event: CalendarEventWithAbsence): Promise<void> {
    if (event.isAbsence) {
      this.handleClickAbsenceEvent(event.meta);
      return;
    }

    const isGhostDeal = Boolean(event?.meta?.isGhostDeal);

    if (isGhostDeal) {
      await this.createDealFromGhostDeal(event);
    } else {
      this.createDealService
        .open({
          data: {
            mode: 'EDIT',
            idDeal: event.meta._id,
          },
        })
        .pipe(
          map((res) => {
            if (res) {
              this.requestElements();
            }
          })
        )
        .subscribe();
    }
  }

  private handleClickAbsenceEvent(event: ClockAbsence.Output): void {
    this.launchModalAbsenceDetails(event);
  }

  private async createDealFromGhostDeal(event: CalendarEventWithAbsence) {
    if (!this.loadingClickGhostEvent) {
      this.loadingClickGhostEvent = event;
      this.draw();

      try {
        const { _id } = await this.calendarSearchService
          .create({
            idDealRecurrence: event.meta._id,
            newDate: event.meta.initDate,
          })
          .pipe(
            finalize(() => {
              this.loadingClickGhostEvent = null;
              this.draw();
            })
          )
          .toPromise();

        this.createDealService
          .open({
            data: {
              mode: 'EDIT',
              idDeal: _id,
              forceReloadOnClose: true,
            },
          })
          .pipe(
            map((res) => {
              if (res) {
                this.requestElements();
              }
            })
          )
          .subscribe();
      } catch (err) {}
    }
  }

  private dateGenerators = {
    [CalendarView.Month]: () => {
      const startOfMonth = moment(this.viewDate).startOf('month').toDate();
      const endOfMonth = moment(this.viewDate).endOf('month').toDate();

      return {
        ...this.searchParams,
        from: format(subDays(startOfMonth, 7), 'YYYY-MM-DD'),
        to: format(addDays(endOfMonth, 7), 'YYYY-MM-DD'),
      };
    },

    [CalendarView.Week]: () => {
      const startOfWeek = format(
        subDays(moment(this.viewDate).startOf('week').toDate(), 7),
        'YYYY-MM-DD'
      );
      const endOfWeek = format(
        addDays(moment(this.viewDate).endOf('week').toDate(), 7),
        'YYYY-MM-DD'
      );

      return {
        ...this.searchParams,
        from: format(startOfWeek, 'YYYY-MM-DD'),
        to: format(endOfWeek, 'YYYY-MM-DD'),
      };
    },

    [CalendarView.Day]: () => {
      const startOfDay = moment(this.viewDate).startOf('day').toDate();
      const endOfDay = moment(this.addDays(this.viewDate, 1))
        .endOf('day')
        .toDate();

      return {
        ...this.searchParams,
        from: format(startOfDay, 'YYYY-MM-DD'),
        to: format(endOfDay, 'YYYY-MM-DD'),
      };
    },
  };

  private generateDate() {
    const generator = this.dateGenerators[this.view];
    if (generator) {
      this.searchParams = generator();
    }
  }

  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  private requestElements() {
    this.isLoading = true;
    this.refreshComponent();

    let getAbsence = false;
    let getOnlyAbsence = false;
    const types: Array<'DEAL' | 'ACTIVITY'> = [];

    if (this.calendar.type.activity) {
      types.push('ACTIVITY');
    }
    if (this.calendar.type.deal) {
      types.push('DEAL');
    }

    if (this.calendar.type.absence) {
      getAbsence = true;
      getOnlyAbsence = !this.calendar.type.deal && !this.calendar.type.activity;
    }

    this.searchParams = {
      ...this.searchParams,
      'types[]': types[0],
    };

    this.events = [];
    this.draw();

    if (getOnlyAbsence) {
      this.resCalendar = {
        recurrences: [],
        deals: [],
        activities: [],
        absences: [],
      };
      this.getAbsences();
      this.refreshComponent();
      return;
    }

    const query = RemoveEmpty(this.searchParams);

    if (this.flightRequest) {
      this.flightRequest.unsubscribe();
      this.flightRequest = new Subscription();
    }

    query['from'] = query['from']
      ? new Date(query['from']).setHours(0, 0, 0, 0)
      : '';
    query['to'] = query['to']
      ? new Date(query['to']).setHours(23, 59, 0, 0)
      : '';

    this.flightRequest = this.calendarSearchService
      .search({ ...query })
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.refreshComponent();
          this.resCalendar = res;
          getAbsence ? this.getAbsences() : this.generateEvents(res);
        },
        () => {
          this.isLoading = false;
          this.refreshComponent();
        }
      );
  }

  private getAbsences() {
    this.isLoading = true;
    this.refreshComponent();
    const searchAbsencesParams = {
      from: this.searchParams.from,
      to: this.searchParams.to,
      ['idCompanies[]']: StorageService.CompanyId,
      limit: 50,
      page: 1,
    };

    if (!this.authService.user?.role?.includes(TypeRol.ADMIN_ROLE)) {
      searchAbsencesParams['idOwners[]'] = this.authService.user._id;
    }

    const query = RemoveEmpty(searchAbsencesParams);

    this.clockAbsenceService.search({ ...query }).subscribe(
      (res) => {
        this.resCalendar.absences = res.docs;
        this.isLoading = false;
        this.refreshComponent();
        this.generateEvents(this.resCalendar);
      },
      () => {
        this.isLoading = false;
        this.refreshComponent();
      },
      () => {
        this.isLoading = false;
        this.refreshComponent();
      }
    );
  }

  private generateEvents(res: CalendarApi.Response) {
    const localEvents: CalendarEventWithAbsence[] = [];

    if (res.absences) {
      for (const absence of res.absences) {
        if (absence.status !== ClockAbsence.Status.Rejected) {
          const absenceMapped = this.attachAbsenceToEvents(absence);

          absenceMapped.map((absence) => {
            localEvents.push(absence);
          });
        }
      }
    }

    for (const deal of res.deals) {
      const event = this.attachToLocalEvents(deal);
      localEvents.push(event);
    }

    for (const deal of res.recurrences) {
      const event = this.attachToLocalEvents(deal);
      localEvents.push(event);
    }

    this.events = localEvents.map((event) => {
      return {
        ...event,
        start: new Date(event.start),
        end: event.end ? new Date(event.end) : null,
      };
    });

    this.refreshComponent();
  }

  private getAbsenceTitle(absences): string {
    const isHalfDay = absences?.typeDetail?.type === ClockAbsence.Type.HalfDay;
    const halfDayType = absences?.typeDetail?.halfDayType;
    const ownerName = absences.owner.name;
    const firstHalfOfDay = ClockAbsence.HalfDayType.FirstHalfOfTheDay;
    const firstHalfText = this.isMobile()
      ? this.i18n.instant('clockAbsence.firstHalfNumericShort')
      : this.i18n.instant('clockAbsence.firstHalfNumeric');
    const secondHalfText = this.isMobile()
      ? this.i18n.instant('clockAbsence.secondHalfNumericShort')
      : this.i18n.instant('clockAbsence.secondHalfNumeric');

    const title =
      isHalfDay && halfDayType
        ? `${
            halfDayType === firstHalfOfDay ? firstHalfText : secondHalfText
          } - ${ownerName}`
        : ownerName;
    return title;
  }

  private attachAbsenceToEvents(absences: ClockAbsence.Output) {
    const listDays = eachDay(
      new Date(absences.dateDetail.startDateUTC),
      new Date(absences.dateDetail.endDateUTC)
    );

    return listDays.map((day) => {
      return {
        id: absences._id,
        start: new Date(day),
        title: this.getAbsenceTitle(absences),
        color: {
          primary: '#D9CEFF',
          secondary: '#D9CEFF',
        },
        draggable: false,
        allDay: true,
        meta: absences,
        isAbsence: true,
      };
    });
  }

  private attachToLocalEvents(deal: {
    status: { color?: string };
    dates?: {
      initTimestamp?: number;
      endTimestamp?: number;
    };
    isAllDay?: boolean;
    name: string;
    final?: { name: string };
    _id?: string;
    isGhostDeal?: boolean;
    id?: string;
  }) {
    const defaultColor = RmCalendar.GetDefaultColor(deal?.status?.color);
    const eventColor = {
      primary: defaultColor.darkColor,
      secondary: defaultColor.lightColor,
    };
    const allDay = !!deal?.isAllDay;

    let title = `${deal?.name || deal?.final?.name}`;

    if (!deal?.isAllDay) {
      title = `${timestampToHour(deal?.dates?.initTimestamp)} - ${title}`;
    }

    const startDate = deal?.dates?.initTimestamp
      ? new Date(deal?.dates?.initTimestamp)
      : null;
    const endDate = deal?.dates?.endTimestamp
      ? new Date(deal?.dates?.endTimestamp)
      : null;

    return {
      id: deal?.isGhostDeal ? deal.id : deal._id,
      start: startDate,
      end: allDay ? null : endDate,
      longTitle: title.length > 23 ? title : '',
      title,
      color: eventColor,
      draggable: !this.isMobile() ? !Deal.IsDealRecurrence(deal) : false,
      allDay,
      meta: {
        ...deal,
        isGhostDeal: deal?.isGhostDeal,
      },
    };
  }

  launchModalAbsenceEdit(evt: ClockAbsence.Output): void {
    this.addClockAbsenceService
      .open({
        data: {
          mode: 'EDIT',
          clockAbsence: evt,
          isAdminAbsences: false,
        },
      })
      .subscribe();
  }

  private watchRefreshList() {
    const refreshAbsenceList = (res: { reload: boolean }) => {
      if (res?.reload) {
        this.requestElements();
      }
    };

    this.sub$.add(
      this.addClockAbsenceService.refreshList$.subscribe(refreshAbsenceList)
    );

    this.sub$.add(
      this.showDetailClockAbsenceService.refreshList$.subscribe(
        refreshAbsenceList
      )
    );
  }

  launchModalAbsenceDetails(evt: ClockAbsence.Output): void {
    this.showDetailClockAbsenceService
      .open({
        data: {
          clockAbsence: evt,
          isAdminAbsences: this.authService.user?.role?.includes(
            TypeRol.ADMIN_ROLE
          ),
        },
      })
      .subscribe();
  }

  redirectToDealDetail(): void {
    this.createDealService.open().subscribe();
  }

  changeFilters(evt: RmFilter.Changes) {
    if (evt.type === 'CHANGE' || evt.type === 'INPUT_CHANGE') {
      const { queryParams } = evt;

      if (
        JSON.stringify(queryParams) === JSON.stringify({}) &&
        evt.type === 'INPUT_CHANGE'
      ) {
        delete this.searchParams.keyword;
      }

      if (
        JSON.stringify(queryParams) === JSON.stringify({}) &&
        evt.type === 'CHANGE'
      ) {
        this.searchParams = { ...InitParams };
        this.generateDate();
      }

      this.searchParams = {
        ...this.searchParams,
        ...queryParams,
      };

      this.searchParams = {
        ...this.searchParams,
        customProperties: queryParams?.customProperties
          ? JSON.stringify(queryParams.customProperties)
          : null,
      };

      this.requestElements();
    }
  }

  private resolveShowEndOfWeek() {
    if (this.calendar.showEndOfWeek) {
      this.excludeDays = [];
    } else {
      const INDEX_DAYS_OF_WEEKEND = [0, 6];
      this.excludeDays = INDEX_DAYS_OF_WEEKEND;
    }

    this.draw();
  }

  private resolveCalendarElementStorage({
    option,
  }: {
    option: 'SAVE' | 'READ';
  }) {
    if (option === 'SAVE') {
      StorageService.SetItem('CALENDAR', JSON.stringify(this.calendar));
    } else if (option === 'READ') {
      const calendarElements = JSON.parse(StorageService.GetItem('CALENDAR'));

      if (calendarElements) {
        this.calendar = calendarElements;
        this.validateActiveModules('CLOCK_HOURS').then((isActive) => {
          this.calendar.type.absence = this.calendar.type.absence && isActive;
          this.resolveShowEndOfWeek();
        });
      }
    }

    const viewMap = {
      MONTH: CalendarView.Month,
      WEEK: CalendarView.Week,
      DAY: CalendarView.Day,
    };

    this.view = viewMap[this.calendar.view] || CalendarView.Day;
    this.draw();
  }

  private validateActiveModules(module: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.idActiveModules$.subscribe((activeModules: string[]) => {
        resolve(activeModules.includes(module));
      });
    });
  }

  private getCompanySettings() {
    const id = StorageService.CompanyId;
    let dayInit = StorageService.FirstDayCalendar;
    this.defaultSettings.budgetPreferences.day = dayInit;
    this.sub$.add(
      this.budgetService
        .findSettingsByCompany(id)
        .pipe(finalize(() => this.draw()))
        .subscribe((resp: IBudgetsSetting) => {
          this.defaultSettings = resp;
          if (resp.budgetPreferences?.day) {
            dayInit = resp.budgetPreferences.day;
            StorageService.SetItem(FIRST_DAY_CALENDAR, dayInit);
          } else {
            this.defaultSettings.budgetPreferences.day = 1;
          }
        })
    );
  }

  private resolveLanguage() {
    const lang = this.i18n.currentLang as Lang;

    this.locale = lang;
    this.draw();
  }

  private watchTranslation() {
    this.sub$.add(
      this.i18n.onLangChange.subscribe(() => {
        this.resolveLanguage();
      })
    );
  }

  private requestDynamicProperties() {
    this.sub$.add(
      this.dynamicPropertyService
        .findDynamicProperties(
          StorageService.CompanyId,
          DynamicPropertyRef.Deal
        )
        .subscribe((res) => {
          this.sourceOptions = SOURCE_WEB_OPTIONS({
            assetService: this.assetService,
            companyModuleService: this.companyModuleService,
            finalService: this.finalService,
            projectService: this.projectService,
            statusService: this.statusService,
            assetSearchService: this.assetSearchService,
            customProperties: res,
            i18n: this.i18n,
          });

          this.draw();
        })
    );
  }

  isMobile(): boolean {
    const isMobilePlatform =
      this.platformService.isAndroid() || this.platformService.isIos();
    const isWebResponsive = window.screen.width < 768;
    return isWebResponsive || isMobilePlatform;
  }

  showDialog(): void {
    if (!this.isMobile()) {
      const [showToolTip] = this.iconDialog;
      const newStatus = !showToolTip;
      this.iconDialog = [newStatus, this.iconDialog[1]];
      this.toggleTooltip(newStatus);
    } else {
      this.dialog.open(ModalMobileInfoComponent, {
        data: {
          html: 'calendar.tooltip',
          buttonText: 'kanban.dialog.confirmButton',
        },
      });
    }
  }

  toggleTooltip(showTooltip: boolean): void {
    if (showTooltip) {
      this.iconDialog = [
        showTooltip,
        'assets/icons/gl_information-clicked.svg',
      ];
    } else {
      this.iconDialog = [
        showTooltip,
        'assets/icons/gl_title-information-outline.svg',
      ];
    }

    this.draw();
  }

  private draw() {
    this.changeDetectorRef.detectChanges();
  }

  transformDayString(date: string): string {
    return window.screen.width < 768
      ? Array.from(date)[0]
      : date?.replace('.', '');
  }

  openDealCard(): void {
    if (!this.checkPermission(FeatureUser.Deal.create)) {
      this.toastService.show({
        text: this.i18n.instant('permissions.errors.permissionStr'),
        type: 'error',
        msDuration: 5000,
      });
      return;
    }
    this.amplitudeService.sendEvent({
      event: AmplitudeEvents.calendar_deal_start,
    });

    this.createDealService
      .open()
      .pipe(
        map((res) => {
          !res;
          if (res) {
            this.requestElements();
          }
        })
      )
      .subscribe();
  }

  sortByAbsence(
    elements: CalendarEventWithAbsence[]
  ): CalendarEventWithAbsence[] {
    return elements.sort((a, b) => {
      if (a.isAbsence && !b.isAbsence) {
        return -1;
      } else if (!a.isAbsence && b.isAbsence) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  sortBy(elements, prop: string) {
    return elements.sort(
      (a, b) =>
        a.allDay - b.allDay ||
        (a[prop] > b[prop]
          ? 1
          : a[prop].getTime() === b[prop].getTime()
          ? 0
          : -1)
    );
  }

  getLang(): string {
    return this.i18n.currentLang;
  }

  openVideo(type: string): void {
    this.amplitudeService.sendEvent({
      event: 'calendar_TutorialVideo',
    });
    this.video.open(type);
  }

  public refreshComponent(): void {
    this.draw();
  }

  get isLowerThan1450px(): boolean {
    return window.innerWidth < 1450;
  }
}
